import type { WidgetCoreDefinition, TeXMLContext, TeXMLElement, ValidationResult } from './types';
import { buildCallbackUrl } from './types';

export const recordingActions = ['start', 'stop'] as const;
export type RecordingAction = (typeof recordingActions)[number];

export type RecordingConfig = {
  action: RecordingAction;
};

function generateTeXML(_config: RecordingConfig, context: TeXMLContext): TeXMLElement[] {
  return [
    {
      tag: 'Redirect',
      attributes: { method: 'POST' },
      content: buildCallbackUrl(context),
    },
  ];
}

function validateConfig(config: RecordingConfig): ValidationResult {
  const errors: string[] = [];

  if (!recordingActions.includes(config.action)) {
    errors.push('Action must be start or stop');
  }

  return { valid: errors.length === 0, errors };
}

export const recordingWidgetCore: WidgetCoreDefinition<RecordingConfig> = {
  id: 'recording',
  version: 1,
  name: 'Recording',
  description: 'Start or stop call recording',
  category: 'voice',
  tier: 'standard',

  defaultConfig: {
    action: 'start',
  },

  texml: {
    generate: generateTeXML,
    requiresCallback: true,
  },

  validation: {
    validateConfig,
  },
};
